/**
 * Forwards the user to the Basket / Mini Shop / Interstitial page.
 * @param {number} productId - The ID of the product being added.
 * @param {number} quantity - The amount of products being added.
 */
export function forwardToBasket(productId: number, quantity: number): void {
	const data = {
		productId: productId,
		qty: quantity,
	};
	window.location.href =
		window.serverData.contextPath + '/basket/add?' + `${new URLSearchParams(data as any)}`;
}
